import './index.scss';
import { SectionData } from 'data/tabData';
import useSticky from 'common-modules/general/Modules/custom-hooks/useSticky';
import MainModel from 'common-modules/general/Common/Logic/Main/MainSalesCommon';
import { toJS } from 'mobx';
import { observer } from 'mobx-react';
import { useLocation } from 'react-router';
import { useEffect } from 'react';
import { RoutesString } from 'common-modules/general/Config/routesString';

interface Props {
  mainModel: MainModel;
}

const TabMenu = observer(({ mainModel }: Props) => {
  const { isTouched } = useSticky({
    stickyElementStaticContainerId: 'fixed-container',
    stickyElementId: 'fixedTab2'
  });

  const location = useLocation();

  useEffect(() => {
    const hash = location.hash.replace('#', '');
    const isHashRoot = hash === '/sales/' || hash === '/';
    const findElement = document.getElementById('fixed-container');

    if (findElement) {
      if (isHashRoot) {
        window.scrollTo(0, 0);
      } else {
        window.scrollTo(0, findElement.offsetTop);
      }
    }
  }, [location.hash]);

  // 서버 통신 이후 데이터 지정. 없을 경우 빈 배열.
  const menuList = toJS(mainModel.mainData.data?.menuList) || [];

  // 서버로부터 탭 메뉴 리스트를 받으면 해당 정보를, 없다면 로컬에 저장된 정보(SectionData)를 바탕으로 메뉴 지정.
  const tabMenuList = menuList && menuList.length > 0 ? menuList : SectionData;

  // 받은 코드를 기준으로 라우팅 지정.
  const changeSrcSectionData = (key: string) => {
    if (key === 'A') {
      return '#/sales/';
    } else if (key === 'B') {
      return '#/sales/info';
    } else if (key === 'C') {
      return '#/sales/exhbt';
    } else if (key === 'D') {
      return '#/sales/location';
    } else if (key === 'E') {
      return '#/sales/street';
    } else if (key === 'F') {
      return '#/sales/household';
    } else if (key === 'G') {
      return '#/sales/event';
    } else if (key === 'H') {
      return '#/sales/news';
    } else {
      return '#/sales/';
    }
  };

  return (
    <div id="fixed-container">
      <div className="lnb-tab-menu" id="fixedTab2">
        {isTouched && (
          <h1 className="headerLogo">
            <a href={RoutesString.Main}>
              <div>e편한세상</div>
            </a>
          </h1>
        )}

        <div className="apt-menu">
          {tabMenuList.map((bar, i) => {
            const pre_txt: string = 'sales/';
            const removeHashString = changeSrcSectionData(bar.mnCode).toLowerCase().replace('#/', '');
            let windowLocationHash = window.location.hash.replace('#/', '');

            if (windowLocationHash === '') {
              windowLocationHash = pre_txt;
            }
            const checkOn: boolean = (removeHashString === windowLocationHash) || (
              removeHashString !== pre_txt && windowLocationHash.includes(removeHashString)
            );
            
            return (
              <a
                key={bar.mnCode}
                className={`menu-link  ${checkOn ? 'on' : ''}`}
                href={changeSrcSectionData(bar.mnCode)}>
                <span className="txt">{bar.mnName}</span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
});

export default TabMenu;
